import React, { useState } from "react"
import Layout from "components/layout"
import SEO from "components/seo"
import { submitContactForm } from "../api/contact"
import { navigate } from "gatsby"

const ContactPage = () => {
  const [data, setData] = useState({
    names: "",
    email: "",
    phone: "",
    company_size: "",
    followup: false,
    own_cbs: false,
  })
  const [followup, setFollowUp] = useState(false)
  const [own_cbs, setOwnCbs] = useState(false)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState({})

  const submitForm = e => {
    e.preventDefault()
    setLoading(true)
    const submission = {
      submittedon_userName: "woodcore",
      UGDtemplate: data,
    }
    submitContactForm(submission)
      .then(data => {
        console.log(data)
        navigate("/")
        setLoading(false)
        setMessage({
          type: "success",
          message: "Thank you, we have received your response.",
        })
      })
      .catch(err => {
        setLoading(false)
      })
  }

  return (
    <Layout active="contact" bottomInfo={false}>
      <SEO title="Contact" />
      <section>
        <div className="bg-snow-100 text-center">
          <div className="h-40 w-full˝"></div>
          <h1 className="font-bold" style={{ fontSize: "48px" }}>
            Contact Us
          </h1>
          <div className="h-32 w-full˝"></div>
        </div>
      </section>

      <section>
        <div className="md:flex items-start my-24 w-11/12 lg:w-10/12 xl:w-8/12 mx-auto">
          <div className="w-full md:w-1/2">
            <h2 className="font-semibold" style={{ fontSize: "36px" }}>
              Hey, Lets get you started. Reach out!
            </h2>
          </div>
          <div className="md:w-1/2 mt-5 md:mt-0">
            <form
              className="w-full lg:w-10/12 ml-auto grid gap-6"
              onSubmit={submitForm}
            >
              <div>
                <input
                  className="border border-grey-300 w-full rounded-sm placeholder-grey-200 px-5"
                  placeholder="Full name"
                  style={{ height: "60px" }}
                  required
                  onChange={e => {
                    setData({
                      ...data,
                      names: e.target.value,
                    })
                  }}
                />
              </div>
              <div>
                <input
                  className="border border-grey-300 w-full rounded-sm placeholder-grey-200 px-5"
                  placeholder="Email"
                  type="email"
                  style={{ height: "60px" }}
                  required
                  onChange={e => {
                    setData({
                      ...data,
                      email: e.target.value,
                    })
                  }}
                />
              </div>
              <div className="relative">
                <input
                  className="border border-grey-300 w-full rounded-sm placeholder-grey-200 pl-16"
                  placeholder="Phone number"
                  type="number"
                  style={{ height: "60px" }}
                  required
                  onChange={e => {
                    setData({
                      ...data,
                      phone: e.target.value,
                    })
                  }}
                />
                <div className="absolute h-full items-center flex top-0 pl-4">
                  <p className="text-sm text-grey-100">+234</p>
                </div>
              </div>
              <div>
                <input
                  className="border border-grey-300 w-full rounded-sm placeholder-grey-200 px-5"
                  placeholder="Company Size"
                  type="number"
                  style={{ height: "60px" }}
                  required
                  onChange={e => {
                    setData({
                      ...data,
                      company_size: e.target.value,
                    })
                  }}
                />
              </div>
              <div className="mt-2">
                <button
                  className="w-full rounded-sm bg-green text-white font-medium text-sm flex items-center justify-center"
                  style={{ height: "60px" }}
                >
                  {loading ? (
                    <img src={require("images/load.svg")} alt="loader" />
                  ) : (
                    "Submit"
                  )}
                </button>
                <div className="md:flex items-center justify-between mt-4">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      value="follow_up"
                      checked={followup}
                      name="follow_up"
                      onChange={e => {
                        setFollowUp(!followup)
                        setData({ ...data, followup: e.target.checked })
                      }}
                    />
                    <p className="text-sm text-grey-100 pl-2">
                      Call for follow up
                    </p>
                  </div>
                  <div className="flex items-center mt-2 md:mt-0">
                    <input
                      type="checkbox"
                      checked={own_cbs}
                      onChange={e => {
                        setOwnCbs(!own_cbs)
                        setData({ ...data, own_cbs: e.target.checked })
                      }}
                    />
                    <p className="text-sm text-grey-100 pl-2">
                      I have a core banking system
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <p className="text-center font-medium text-green">
                  {message.message}
                </p>
              </div>
            </form>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default ContactPage
